import React, {useState} from 'react';
import { Box, Typography} from '@mui/material';

const OurStoriesGetToKnow=(props: any) => {
    const [GetToKnowSectionData, setGetToKnowSection] = useState<null | any>(props.data[0].field_description || null);
    const [GetToKnowSectiontitle, setGetToKnowSectiontitle] = useState<null | any>(props.data[0].title || null);
    
    return (
        <React.Fragment>
             <Box textAlign='center'>
                <Typography variant="h1" fontSize='36px' mb="20px">
                {GetToKnowSectiontitle}
                </Typography>
                <Typography component="p" fontSize='25px' mb={{xs:"30px", lg:"86px"}} maxWidth='951px' mx='auto'>
                    {GetToKnowSectionData}
                </Typography>
            </Box> 
            </React.Fragment>
    );
};


export default OurStoriesGetToKnow;
